//Assign custom thumbnail images (4 icons displayed below hero image on product page, based on model AND color) | SortinoSoft
(function() {
  'use strict';
  
  // Configuration: Map model + color to arrays of custom images
  // Each array can have up to 4 images (positions 0-3 for thumbnails 1-4)
  // Set array position to null to use the default image for that thumbnail
  if (isOctoPage()) {
    var customImages = {
      'iPhone 17': {
        'Black/Black': ['octopouch-iphone-17-black-black-1.jpg', null, null, 'octopouch-iphone-17-black-black-4.jpg'],
        'Black/Clear': ['octopouch-iphone-17-black-clear-1.jpg', null, null, 'octopouch-iphone-17-black-clear-4.jpg'],
        'Lavender/Lavender': ['octopouch-iphone-17-lavender-lavender-1.jpg', null, null, 'octopouch-iphone-17-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['octopouch-iphone-17-lavender-clear-1.jpg', null, null, 'octopouch-iphone-17-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['octopouch-iphone-17-blue-blue-1.jpg', null, null, 'octopouch-iphone-17-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['octopouch-iphone-17-blue-clear-1.jpg', null, null, 'octopouch-iphone-17-blue-clear-4.jpg'],
        'Mocha/Mocha': ['octopouch-iphone-17-mocha-mocha-1.jpg', null, null, 'octopouch-iphone-17-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['octopouch-iphone-17-mocha-clear-1.jpg', null, null, 'octopouch-iphone-17-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['octopouch-iphone-17-matcha-matcha-1.jpg', null, null, 'octopouch-iphone-17-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['octopouch-iphone-17-matcha-clear-1.jpg', null, null, 'octopouch-iphone-17-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['octopouch-iphone-17-pink-bubblegum-1.jpg', null, null, 'octopouch-iphone-17-pink-bubblegum-4.jpg'],
        'Pink/Clear': ['octopouch-iphone-17-pink-clear-1.jpg', null, null, 'octopouch-iphone-17-pink-clear-4.jpg']
        // -------------------------
      },
      // ---- iPhone Duo ----
      // Mismo criterio que en Flex: una sola foto por color, repetida en las
      // cuatro posiciones, y las miniaturas ocultas desde singleImageModels.
      'iPhone Duo': {
        'Pink/Princess Sparkles': ['octoduo-pink.jpg', 'octoduo-pink.jpg', 'octoduo-pink.jpg', 'octoduo-pink.jpg'],
        'Black/Clear': ['octoduo-black.jpg', 'octoduo-black.jpg', 'octoduo-black.jpg', 'octoduo-black.jpg']
      },
      // --------------------
      'iPhone 17 Air': {
        'Black/Black': ['octopouch-iphone-17-air-black-black-1.jpg', null, null, 'octopouch-iphone-17-air-black-black-4.jpg'],
        'Black/Clear': ['octopouch-iphone-17-air-black-clear-1.jpg', null, null, 'octopouch-iphone-17-air-black-clear-4.jpg'],
        'Lavender/Lavender': ['octopouch-iphone-17-air-lavender-lavender-1.jpg', null, null, 'octopouch-iphone-17-air-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['octopouch-iphone-17-air-lavender-clear-1.jpg', null, null, 'octopouch-iphone-17-air-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['octopouch-iphone-17-air-blue-blue-1.jpg', null, null, 'octopouch-iphone-17-air-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['octopouch-iphone-17-air-blue-clear-1.jpg', null, null, 'octopouch-iphone-17-air-blue-clear-4.jpg'],
        'Mocha/Mocha': ['octopouch-iphone-17-air-mocha-mocha-1.jpg', null, null, 'octopouch-iphone-17-air-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['octopouch-iphone-17-air-mocha-clear-1.jpg', null, null, 'octopouch-iphone-17-air-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['octopouch-iphone-17-air-matcha-matcha-1.jpg', null, null, 'octopouch-iphone-17-air-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['octopouch-iphone-17-air-matcha-clear-1.jpg', null, null, 'octopouch-iphone-17-air-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['octopouch-iphone-17-air-pink-bubblegum-1.jpg', null, null, 'octopouch-iphone-17-air-pink-bubblegum-4.jpg'],
        'Pink/Clear': ['octopouch-iphone-17-air-pink-clear-1.jpg', null, null, 'octopouch-iphone-17-air-pink-clear-4.jpg']
        // -------------------------
      }
    };  
  } else {
    var customImages = {
      'iPhone 17': {
        'Black/Black': ['iphone-17-black-black-1.jpg', null, null, 'iphone-17-black-black-4.jpg'],
        'Black/Clear': ['iphone-17-black-clear-1.jpg', null, null, 'iphone-17-black-clear-4.jpg'],
        'Lavender/Lavender': ['iphone-17-lavender-lavender-1.jpg', null, null, 'iphone-17-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['iphone-17-lavender-clear-1.jpg', null, null, 'iphone-17-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['iphone-17-blue-blue-1.jpg', null, null, 'iphone-17-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['iphone-17-blue-clear-1.jpg', null, null, 'iphone-17-blue-clear-4.jpg'],
        'Mocha/Mocha': ['iphone-17-mocha-mocha-1.jpg', null, null, 'iphone-17-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['iphone-17-mocha-clear-1.jpg', null, null, 'iphone-17-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['iphone-17-matcha-matcha-1.jpg', null, null, 'iphone-17-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['iphone-17-matcha-clear-1.jpg', null, null, 'iphone-17-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['iphone-17-pink-bubblegum-1.jpg', null, null, 'iphone-17-pink-bubblegum-4.jpg'],
        'Pink/Princess Sparkles': ['iphone-17-pink-princesssparkles-1.jpg', null, null, 'iphone-17-pink-princesssparkles-4.jpg']
        // -------------------------
      },
      'iPhone 17 Air': {
        'Black/Black': ['iphone-17-air-black-black-1.jpg', null, null, 'iphone-17-air-black-black-4.jpg'],
        'Black/Clear': ['iphone-17-air-black-clear-1.jpg', null, null, 'iphone-17-air-black-clear-4.jpg'],
        'Lavender/Lavender': ['iphone-17-air-lavender-lavender-1.jpg', null, null, 'iphone-17-air-lavender-lavender-4.jpg'],
        'Lavender/Clear': ['iphone-17-air-lavender-clear-1.jpg', null, null, 'iphone-17-air-lavender-clear-4.jpg'],
        'Baby Blue/Baby Blue': ['iphone-17-air-blue-blue-1.jpg', null, null, 'iphone-17-air-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['iphone-17-air-blue-clear-1.jpg', null, null, 'iphone-17-air-blue-clear-4.jpg'],
        'Mocha/Mocha': ['iphone-17-air-mocha-mocha-1.jpg', null, null, 'iphone-17-air-mocha-mocha-4.jpg'],
        'Mocha/Clear': ['iphone-17-air-mocha-clear-1.jpg', null, null, 'iphone-17-air-mocha-clear-4.jpg'],
        'Matcha/Matcha': ['iphone-17-air-matcha-matcha-1.jpg', null, null, 'iphone-17-air-matcha-matcha-4.jpg'],
        'Matcha/Clear': ['iphone-17-air-matcha-clear-1.jpg', null, null, 'iphone-17-air-matcha-clear-4.jpg'],
        // ---- NEW PINK COLORS ----
        'Pink/Bubble Gum': ['iphone-17-air-pink-bubblegum-1.jpg', null, null, 'iphone-17-air-pink-bubblegum-4.jpg'],
        'Pink/Princess Sparkles': ['iphone-17-air-pink-princesssparkles-1.jpg', null, null, 'iphone-17-air-pink-princesssparkles-4.jpg']
        // -------------------------
      },
      // ---- iPhone Duo ----
      // Este modelo tiene una sola foto por color, no cuatro vistas. Se repite
      // el mismo archivo en las cuatro posiciones y la tira de miniaturas se
      // oculta desde singleImageModels, mas abajo. Repetir el archivo, en vez
      // de dejar null, evita que las posiciones 2 a 4 se queden con las fotos
      // del modelo anterior.
      //
      // Solo estan los colores que tienen foto Duo propia. Un color que no
      // aparezca aqui cae en el comportamiento normal y muestra sus cuatro
      // fotos de siempre, que es lo correcto mientras no exista su foto Duo.
      'iPhone Duo': {
        'Pink/Princess Sparkles': ['duo-pink_JPG.jpg', 'duo-pink_JPG.jpg', 'duo-pink_JPG.jpg', 'duo-pink_JPG.jpg'],
        'Black/Clear': ['duo-black.jpg', 'duo-black.jpg', 'duo-black.jpg', 'duo-black.jpg']
      },
      // --------------------
      'iPhone 17e': {
        'Black/Clear': ['iphone-17-black-clear-1.jpg', null, null, 'iphone-17-black-clear-4.jpg'],
        'Black/Black': ['iphone-17-black-black-1.jpg', null, null, 'iphone-17-black-black-4.jpg'],
        'Lavender/Clear': ['iphone-17-lavender-clear-1.jpg', null, null, 'iphone-17-lavender-clear-4.jpg'],
        'Lavender/Lavender': ['iphone-17-lavender-lavender-1.jpg', null, null, 'iphone-17-lavender-lavender-4.jpg'],
        'Mocha/Clear': ['iphone-17-mocha-clear-1.jpg', null, null, 'iphone-17-mocha-clear-4.jpg'],
        'Mocha/Mocha': ['iphone-17-mocha-mocha-1.jpg', null, null, 'iphone-17-mocha-mocha-4.jpg'],
        'Baby Blue/Baby Blue': ['iphone-17-blue-blue-1.jpg', null, null, 'iphone-17-blue-blue-4.jpg'],
        'Baby Blue/Clear': ['iphone-17-blue-clear-1.jpg', null, null, 'iphone-17-blue-clear-4.jpg'],
        'Matcha/Clear': ['iphone-17-matcha-clear-1.jpg', null, null, 'iphone-17-matcha-clear-4.jpg'],
        'Matcha/Matcha': ['iphone-17-matcha-matcha-1.jpg', null, null, 'iphone-17-matcha-matcha-4.jpg']
      },
    };
  }
  
  // El mapa busca por el nombre del modelo tal y como aparece en el selector.
  // Esa variante se llamaba "iPhone Duo" y se renombro a "iPhone 18 Duo", lo
  // que dejo de encontrar la entrada y la ficha volvio a mostrar las fotos del
  // modelo anterior, sin ningun error en consola.
  //
  // Se declaran las dos grafias apuntando al mismo mapa. La que no exista nunca
  // llega a coincidir, de modo que sobra sin estorbar, y un renombrado futuro
  // entre esas dos formas no vuelve a romperlo. Si se renombra a otra cosa
  // distinta, hay que anadirla a esta lista.
  const modelAliases = [['iPhone Duo', 'iPhone 18 Duo']];
  modelAliases.forEach(function (names) {
    const existing = names.filter(function (n) { return customImages[n]; })[0];
    if (!existing) return;
    names.forEach(function (n) {
      if (!customImages[n]) customImages[n] = customImages[existing];
    });
  });

  // Base CDN path (update this to your actual path)
  const cdnBasePath = '//ninjalabs.com/cdn/shop/files/';
  
  // Store which thumbnails have been customized (so we know which to restore)
  let customizedThumbnails = new Set();
  
  // Track if we're currently using custom images
  let currentlyUsingCustomImages = false;
  
  // Debug mode - set to true to see console logs
  const DEBUG = false;
  
  function log(...args) {
    if (DEBUG) console.log('[CustomImages]', ...args);
  }
  
  // Get current selections
  function getCurrentColor() {
    const checkedInput = document.querySelector('input[name="options[' + colorLang + ']"]:checked');
    // Los dos console.log de aqui leian checkedInput.value antes de comprobar
    // que existiera, asi que si ningun color estaba marcado la funcion lanzaba
    // un TypeError y se llevaba por delante el resto del archivo. Ademas
    // escribian en la consola de produccion al margen de DEBUG.
    if (!checkedInput) return null;
    log('color seleccionado:', checkedInput.value, '->', colorTranslations[checkedInput.value]);
    return colorTranslations[checkedInput.value];
  }
  
  function getCurrentModel() {
    const modelInput = document.querySelector('input[data-input="model"]');
    return modelInput ? modelInput.value : null;
  }
  
  // Check if current model should use custom images
  function shouldUseCustomImage() {
    const model = getCurrentModel();
    const should = model && customImages.hasOwnProperty(model);
    log('shouldUseCustomImage?', should, '(model:', model, ')');
    return should;
  }
  
  // Get custom images array for current model + color
  function getCustomImagesArray() {
    const model = getCurrentModel();
    const color = getCurrentColor();
    
    // La lectura de customImages[model][color] estaba antes de la comprobacion,
    // asi que reventaba en cuanto el modelo no estuviera en el mapa.
    if (!model || !color || !customImages[model] || !customImages[model][color]) {
      return null;
    }
    
    return customImages[model][color];
  }
  
  // Modelos que se muestran con una sola foto, sin vistas adicionales.
  // La tira de miniaturas se oculta mientras uno de ellos este seleccionado y
  // vuelve a aparecer al cambiar a cualquier otro.
  const singleImageModels = ['iPhone Duo', 'iPhone 18 Duo'];

  function isSingleImageModel() {
    const model = getCurrentModel();
    return !!model && singleImageModels.indexOf(model) !== -1;
  }

  function setThumbnailsVisible(visible) {
    const strip = document.getElementById('ProductThumbs');
    if (!strip) return;

    strip.style.display = visible ? '' : 'none';
    if (!visible) return;

    // La tira es un carrusel de Flickity. Flickity cachea el alto del viewport,
    // y si algo lo hace remedirse mientras el contenedor esta en display:none,
    // se queda con cero y no lo recalcula solo al volver a mostrarlo: las
    // miniaturas siguen en el DOM, cargadas y de 88px cada una, pero el padre
    // mide 0 y no se ve ninguna. Por eso hay que pedirle el recalculo a mano.
    // Se hace dos veces porque en el primer frame el contenedor puede no tener
    // aun sus dimensiones finales.
    const relayout = function () {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        const flkty = window.Flickity.data(strip);
        if (flkty && typeof flkty.resize === 'function') flkty.resize();
      }
      window.dispatchEvent(new Event('resize'));
    };

    requestAnimationFrame(relayout);
    setTimeout(relayout, 300);
  }

  // Get all thumbnail image elements
  function getAllThumbnails() {
    return document.querySelectorAll('.product-single__thumbnail-img');
  }
  
  // Get specific thumbnail by index (0-based)
  function getThumbnail(index) {
    const thumbnails = getAllThumbnails();
    return thumbnails[index] || null;
  }
  
  // Get ALL hero images (one for each thumbnail)
  function getAllHeroImages() {
    return document.querySelectorAll('[data-product-image]');
  }
  
  // Get specific hero image by index (0-based)
  function getHeroImage(index) {
    const heroImages = getAllHeroImages();
    return heroImages[index] || null;
  }
  
  // Generate srcset for an image
  function generateSrcset(baseUrl, widths) {
    return widths.map(width => {
      return `${baseUrl}?v=1757984572&width=${width} ${width}w`;
    }).join(', ');
  }
  
  // Update a specific thumbnail with custom image
  function updateThumbnailWithCustom(index, customFileName) {
    const thumbnail = getThumbnail(index);
    if (!thumbnail) return;
    
    const color = getCurrentColor();
    const model = getCurrentModel();
    
    log('Updating thumbnail', index, 'with custom image:', customFileName);
    const customImageUrl = cdnBasePath + customFileName;
    
    // Widths for thumbnail srcset
    const thumbnailWidths = [90, 180, 1200];
    const thumbnailSrcset = generateSrcset(customImageUrl, thumbnailWidths);
    
    thumbnail.src = customImageUrl;
    thumbnail.setAttribute('data-src', customImageUrl);
    thumbnail.srcset = thumbnailSrcset;
    thumbnail.setAttribute('data-srcset', thumbnailSrcset);
    thumbnail.alt = color + ' - ' + model;
    
    // Mark this thumbnail as customized
    customizedThumbnails.add(index);
  }
  
  // Update specific hero image with custom image
  function updateHeroImageWithCustom(index, customFileName) {
    const heroImage = getHeroImage(index);
    if (!heroImage) {
      log('Could not find hero image at index', index);
      return;
    }
    
    const color = getCurrentColor();
    const model = getCurrentModel();
    
    log('Updating hero image', index, 'with custom:', customFileName);
    const customImageUrl = cdnBasePath + customFileName;
    
    // Widths for hero image srcset
    const heroWidths = [245, 320, 365, 410, 490, 640, 753, 848, 980, 1024, 1200];
    const heroSrcset = generateSrcset(customImageUrl, heroWidths);
    
    heroImage.src = customImageUrl + '?crop=center&height=1200&v=1757984572&width=1200';
    heroImage.setAttribute('data-src', customImageUrl + '?crop=center&height=1200&v=1757984572&width=1200');
    heroImage.srcset = heroSrcset;
    heroImage.setAttribute('data-srcset', heroSrcset);
    heroImage.alt = color + ' - ' + model;
  }
  
  // Trigger Shopify to reload images for current color
  function triggerShopifyImageUpdate() {
    log('Triggering Shopify image update');
    
    const colorInput = document.querySelector('input[name="options[' + colorLang + ']"]:checked');
    if (!colorInput) return;
    
    // Trigger a change event to make Shopify reload images
    const event = new Event('change', { bubbles: true });
    colorInput.dispatchEvent(event);
  }
  
  // Update all images based on current selections
  function updateImages() {
    const color = getCurrentColor();
    const model = getCurrentModel();
    const useCustom = shouldUseCustomImage();
    
    log('updateImages called - Color:', color, 'Model:', model, 'UseCustom:', useCustom);
    
    if (useCustom) {
      const customImagesArray = getCustomImagesArray();
      
      if (customImagesArray && Array.isArray(customImagesArray)) {
        log('Using custom images array:', customImagesArray);
        currentlyUsingCustomImages = true;
        
        // Update each thumbnail position AND its corresponding hero image
        for (let i = 0; i < customImagesArray.length; i++) {
          const customFileName = customImagesArray[i];
          
          if (customFileName) {
            // En los modelos de una sola foto las miniaturas estan ocultas, asi
            // que no hay ninguna razon para reescribirlas. Y si se reescriben,
            // Flickity se remide con la tira oculta y se queda a cero, que es
            // justo lo que rompia la vuelta a 18 Pro. No tocarlas evita el
            // problema en origen; el recalculo de setThumbnailsVisible queda
            // como red de seguridad.
            if (!isSingleImageModel()) {
              updateThumbnailWithCustom(i, customFileName);
            }
            updateHeroImageWithCustom(i, customFileName);
          }
        }

        setThumbnailsVisible(!isSingleImageModel());

      } else {
        log('No custom images found for', model, color);
        currentlyUsingCustomImages = false;
        setThumbnailsVisible(true);
      }
      
    } else {
      setThumbnailsVisible(true);

      // Switching to non-custom model (Pro/Pro Max)
      if (currentlyUsingCustomImages) {
        log('Switching from custom to default model');
        
        // Clear the customized thumbnails set
        customizedThumbnails.clear();
        currentlyUsingCustomImages = false;
        
        // Let Shopify update all images by triggering a color change
        triggerShopifyImageUpdate();
        
      } else {
        log('Non-custom model, letting Shopify handle everything');
        // Do nothing - let Shopify's code work normally
      }
    }
  }
  
  // Listen for color swatch changes
  function attachColorListeners() {
    const colorInputs = document.querySelectorAll('input[name="options[' + colorLang + ']"]');
    colorInputs.forEach(input => {
      input.addEventListener('change', function() {
        log('Color changed to:', this.value);
        
        // When color changes on non-custom model, just clear our tracking
        if (!shouldUseCustomImage()) {
          customizedThumbnails.clear();
        }
        
        // Add delay to run AFTER Shopify's built-in image swap
        setTimeout(() => {
          updateImages();
        }, 50);
      });
    });
  }
  
  // Listen for model dropdown changes
  function attachModelListeners() {
    // Listen to the custom dropdown options
    const modelOptions = document.querySelectorAll('[data-popout-option]');
    modelOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        log('Model option clicked:', this.getAttribute('data-value'));
        
        // Clear customized thumbnails tracking
        customizedThumbnails.clear();
        
        // Small delay to let the hidden input update and Shopify to update images
        setTimeout(() => {
          updateImages();
        }, 250);
      });
    });
    
    // Also listen to the hidden input directly (belt and suspenders approach)
    const modelInput = document.querySelector('input[data-input="model"]');
    if (modelInput) {
      // Use MutationObserver to watch for value changes
      const observer = new MutationObserver(() => {
        log('Model input changed via mutation observer');
        
        // Clear customized thumbnails tracking
        customizedThumbnails.clear();
        
        setTimeout(() => {
          updateImages();
        }, 250);
      });
      
      observer.observe(modelInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }
  
  // Initialize on page load
  function initSwap() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    log('Initializing custom images script');
    
    // Update images based on initial state
    updateImages();
    
    // Attach event listeners
    attachColorListeners();
    attachModelListeners();
    
    log('Initialization complete');
  }
  
  initSwap();
  
})();
